import React, { useState, useImperativeHandle, forwardRef } from "react";
//import { Search } from "lucide-react"; // or any icon library you use

const SearchBar = forwardRef(({ onSearch }, ref) => {
  const [query, setQuery] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    onSearch?.(value); // Call parent search handler if provided
  };

  const clearInput = () => {
    setQuery("");
    onSearch?.("");
  };

  // Expose a method to clear the search box
  useImperativeHandle(ref, () => ({
    clearSearch: () => {
      setQuery("");
      onSearch?.("");
    },
  }));

  return (
    <div className="h-full w-full flex items-center bg-white rounded-[12px] border shadow-md border-gray-300 px-3">
      <input
        type="text"
        value={query}
        onChange={handleChange}
        placeholder="Search Menu"
        className="h-full w-full lg:px-10 md:px-10 px-2 outline-none bg-transparent font-outfit font-medium text-boonsdarkbg placeholder-text-textgray lg:text-[44px] md:text-[32px] sm:text-[24px] text-3px"
      />
      {/* Clear Button (X) */}
      {query.length > 0 && (
        <button onClick={clearInput} className="text-boonsdarkbg hover:text-boonsdarkbg text-[45px] font-outfit font-medium" >
          ×
        </button>
      )}
    </div>
  );
});

SearchBar.displayName = 'SearchBar';
export default SearchBar;
